import { useMemo } from 'react';
import useCognitoGroups from './useCognitoGroups';

/**
 * Checks if the current user has Admin role via Cognito groups.
 * Groups come from JWT token (cognito:groups claim), e.g. ["ResourceAdmin", "Admin"]
 */
const useIsAdmin = () => {
  const groups = useCognitoGroups();

  return useMemo(() => {
    return groups.some((g) => String(g).trim() === 'ResourceAdmin');
  }, [groups]);
};

export default useIsAdmin;
